export default "__VITE_ASSET__BsnjDLh2__"